import _ from 'lodash'
import Vue from 'vue'

export default class {
  /**
   * Constructor
   */
  constructor (data, $el, $store) {
    this.data = data
    this.$el = $el
    this.$store = $store

    this.id = this.data.ID_country_code
    this.year = this.data.ID_year
    this.name = Vue.filter('fixedName')(this.data.ID_country_name)
  }

  /**
   * Return regime name
   */
  regimeName () {
    let dem = parseInt(this.data.dem)
    let demperf = parseInt(this.data.demperf)
    let demObj = _.find(this.$store.state.rsc.dem, { dem: dem })

    if (!dem || !demObj) { return false }

    if (!demperf) {
      return (dem < 3) ? demObj.name : demPerfObj.name + ' ' + demObj.name
    }

    let demPerfObj = _.find(this.$store.state.rsc.demperf, { demperf: demperf })
    return (dem < 3) ? demObj.name : demPerfObj.name + ' ' + demObj.name
  }

  /**
   * Return the color of a regime
   */
  attributeColor (attr) {
    let val = this.attributeValue(attr)
    return Vue.filter('valueColor')(val)
  }

  /**
   * Return the hex value of a attribute color
   */
  attributeHexColor (attr) {
    let color = _.find(this.$store.state.colors, { name: this.attributeColor(attr) })
    return color && color.hex ? color.hex : ''
  }

  /**
   * Return the color of a regime
   */
  regimeColor () {
    return Vue.filter('regimeColor')(this.data)
  }

  /**
   * Return the hex value of a regime color
   */
  regimeHexColor () {
    let color = _.find(this.$store.state.colors, { name: this.regimeColor() })
    return color && color.hex ? color.hex : ''
  }

  /**
   * Returns the value of an attribute
   */
  attributeValue (key) {
    return this.data[key]
  }

  /**
   * Return the high/watch indication of the entire country
   */
  incidentType () {
    return this.$store.getters['covid19/countryType'](this.id)
  }

  /**
   * Return the high/watch indication for an attribute
   */
  countryAttributeType (attr) {
    return this.$store.getters['covid19/countryAttributeType'](this.id, attr)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/CountryClass.js